import React, {
  FC, useEffect, useRef, useState,
} from 'react';
import { OptionDiv, OptionInput, RowCenter, Row } from './Styles';
import { sendGreen } from '../../../../../../../assets/base64Images/ai/sendGreen';
import { sendGray } from '../../../../../../../assets/base64Images/ai/sendGray';
import { keyboard } from '../../../../../../../assets/base64Images/ai/keyboard';
import Button from '../../Button/Button';
import TempFieldUtils from '../../../../../../../lib/TempFieldUtils';
import { lang } from '../../../../../../../lib/utils/utils';

const UnitNoInput: FC<Props> = ({
  callback,
  readonly,
  flowId,
}) => {
  const placeholderRef = useRef<any>();
  const [hasClick, setHasClick] = useState<boolean>(false);
  const [unitNo, setUnitNo] = useState<string>();

  useEffect(() => {
    const interval = setInterval(() => {
      if (placeholderRef.current) {
        placeholderRef.current.placeholder = lang('Enter here…', '此处输入...');
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <Row>
      <OptionDiv>
        <RowCenter>
          <img src={keyboard} style={{ width: 30, height: 18 }} />
          <OptionInput
            type="text"
            readOnly={readonly}
            ref={placeholderRef}
            style={{ width: 83, marginLeft: 10 }}
            value={unitNo}
            onChange={(e) => {
              setUnitNo(e.target.value);
            }}
          />
        </RowCenter>
      </OptionDiv>

      <Button
        style={{
          border: 'unset',
          padding: 'unset',
          height: 'unset',
          marginLeft: 10,
        }}
        callback={() => {
          if (unitNo) {
            if (flowId) {
              // 如果已经点击过一次了，不允许再次点击
              if (TempFieldUtils.aiFlowIds.includes(flowId)) {
                return;
              }
              TempFieldUtils.aiFlowIds.push(flowId);
            }
            setHasClick(true);
            callback(unitNo);
          }
        }}
      >
        <img src={!unitNo || hasClick ? sendGray : sendGreen} style={{ width: 41, height: 41 }} />
      </Button>
    </Row>
  );
};

export interface Props {
  callback: (code: string) => void;
  readonly?: boolean;
  // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
  flowId?: string;
}

export default UnitNoInput;
